import React, { PureComponent } from 'react'

// local components
import AdjustmentItem from './AdjustmentItem'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'

const AdjustmentItemEditable = EditableHOCWrapper(AdjustmentItem)

class AdjustmentItemContainer extends PureComponent {
  onSave = (data, afterOnSave) => {
    this.props.onSave(data, afterOnSave)
  }

  render() {
    const {
      adjustment = {},
      lastModified = null,
      defaultEditMode = false,
      onCancel,
      onDelete,
    } = this.props

    return (
      <AdjustmentItemEditable
        dataToEdit={adjustment}
        onSave={this.onSave}
        lastModified={lastModified}
        defaultEditMode={defaultEditMode}
        onCancel={onCancel}
        onDelete={onDelete}
      />
    )
  }
}

export default AdjustmentItemContainer



// WEBPACK FOOTER //
// ./src/components/Adjustments/AdjustmentItemContainer.js